import { Input, message } from 'ant-design-vue'
import MobileVerification from './MobileVerification.vue'
import './index.less'

/* istanbul ignore next */
MobileVerification.install = function (Vue) {
  Vue.use(Input)
  Vue.prototype.$message = message
  Vue.component(MobileVerification.name, MobileVerification)
}

export default MobileVerification
